export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9133.4ca25a81.jpg";